export default __webpack_public_path__ + "static/media/language.2ebb874b.svg";